import { getDate } from '@utils/dates';
import { wordsToSentence } from '@utils/textHelper';

const getName = (person) => {
  return person?.name || `${person?.firstName} ${person?.lastName}`;
};

const creators = (authors) => {
  if (Array.isArray(authors)) {
    return authors.map((author) => ({
      '@type': 'Person',
      name: getName(author)
    }));
  }
  return {
    '@type': 'Person',
    name: getName(authors)
  };
};

function freeLessonCourseSchema(course) {
  if (Object.keys(course).length === 0 || !course.name) return null;
  const {
    thumbnail,
    topic,
    name,
    authors,
    author,
    description,
    permalink,
    forPlus,
    goal = {},
    cover_photo,
    uid,
    language,
    languages
  } = course;
  if (!goal) return null;
  const authorInfo = authors ? authors[0] : author ?? {};
  return {
    '@context': 'https://schema.org/',
    '@type': 'Course',
    image: thumbnail,
    courseCode: uid,
    accessMode: ['auditory', 'visual'],
    url: permalink,
    thumbnailUrl: cover_photo || thumbnail,
    provider: {
      '@type': 'Organization',
      name: getName(authorInfo),
      sameAs: `https://unacademy.com/@${authorInfo?.username}`
    },
    about: { name: topic },
    audience: {
      audienceType: [`Anyone Prepearing for ${goal.name}`],
      '@type': 'Audience'
    },
    name,
    inLanguage: language || wordsToSentence(languages, 'label', ', ', ', '),
    publisher: {
      '@type': 'Organization',
      name: 'Unacademy',
      sameAs: 'https://unacademy.com/'
    },
    description,
    '@id': permalink,
    creator: creators(authors || author),
    isAccessibleForFree: forPlus
      ? 'http://schema.org/False'
      : 'http://schema.org/True',
    hasCourseInstance: [
      {
        '@type': 'CourseInstance',
        courseMode: ['Online', 'Distance Learning'],
        startDate: getDate(course.startsAt)
      }
    ]
  };
}

export default freeLessonCourseSchema;
